import React from 'react';

import { Icon, Image, Initials, Notification, Wrapper } from './wrapper';

export interface AvatarImageProps {
  src: string;
  srcSet?: string;
  alt: string;
  contain?: boolean;
}

export interface AvatarProps {
  initials?: string;
  image?: AvatarImageProps;
  logotype?: AvatarImageProps;
  icon?: React.ReactNode;
  size?: 'tiny' | 'small' | 'medium' | 'large';
  tone?: 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info' | 'neutral';
  variant?: 'square';
  notification?: React.ReactNode;
}

const Avatar = ({
  initials,
  image,
  logotype,
  icon,
  size,
  tone,
  variant,
  notification,
}: AvatarProps) => (
  <Wrapper $tone={image ? undefined : tone} $size={size} $variant={variant}>
    {image && (
      <Image
        src={image.src}
        srcSet={image.srcSet}
        alt={image.alt}
        $contain={image.contain}
        $size={size}
      />
    )}
    {logotype && (
      <Image
        src={logotype.src}
        srcSet={logotype.srcSet}
        alt={logotype.alt}
        $logotype
        $size={size}
      />
    )}
    {initials && <Initials>{initials}</Initials>}
    {icon && <Icon>{icon}</Icon>}
    {notification && <Notification>{notification}</Notification>}
  </Wrapper>
);

export default Avatar;
